// External Imports
import { connectRouter } from 'connected-react-router';
import reduceReducers from 'reduce-reducers';
import { combineReducers } from 'redux';

// Internal Imports
import { abTesterReducer } from './abTesterReducer.js';
import { activeReducer } from './activeReducer.js';
import { archiveReducer } from './archiveReducer.js';
import { combineEntityReducers } from './combineEntityReducers.js';
import { defaultState } from '../config/defaultState.js';
import { RECEIVE_PRIMARY_CONTENT, RECEIVE_SITE_OPTIONS } from '../config/types/action.js';
import { createContentGroupReducer } from './createContentGroupReducer.js';
import { createOptionReducer } from './createOptionReducer.js';
import { featureFlagReducer } from './featureFlagReducer.js';
import { landingPageReducer } from './landingPageReducer.js';
import { menuReducer } from './menuReducer.js';
import { userReducer } from './userReducer.js';
import { siteOptionsErrorReducer } from './siteOptionsErrorReducer.js';

// Local Functions
function createRootReducer(history) {
  const sliceReducers = combineReducers({
    abTester: abTesterReducer,
    active: (state = defaultState.active) => state,
    archive: (state = defaultState.archive) => state,
    contentItem: createContentGroupReducer('contentType'),
    featureFlags: featureFlagReducer,
    landingPage: (state = defaultState.landingPage) => state,
    languagePicker: createOptionReducer('languagePicker'),
    languages: createOptionReducer('languages'),
    menu: menuReducer,
    router: connectRouter(history),
    siteOptionsError: siteOptionsErrorReducer,
    socialMedia: createOptionReducer('socialMedia'),
    term: createContentGroupReducer('taxonomy'),
    translations: createOptionReducer('translations'),
    user: userReducer,
    ...combineEntityReducers({
      author: RECEIVE_PRIMARY_CONTENT,
      contentType: RECEIVE_SITE_OPTIONS,
      footer: RECEIVE_SITE_OPTIONS,
      info: RECEIVE_SITE_OPTIONS,
      redirect: RECEIVE_SITE_OPTIONS,
      taxonomy: RECEIVE_SITE_OPTIONS,
    }),
  });
  return reduceReducers(sliceReducers, archiveReducer, landingPageReducer, activeReducer);
}

// Module Exports
export { createRootReducer };
